import { useReveal } from "@/hooks/useReveal";
import { useLenis } from "@/components/SmoothScrollProvider";

const TIERS = [
  {
    label: "BY THE YARD",
    line: "$2 to $10 per yard, depending on quality and quantity.",
  },
  {
    label: "BY THE POUND",
    line: "$1 to $3.50 per pound, depending on quality and quantity.",
  },
  {
    label: "CONTAINER LOADS",
    cta: "Contact us",
    line: "for volume pricing.",
  },
];

export const PricingSection = () => {
  const lenis = useLenis();
  const [ref, shown] = useReveal({ threshold: 0.2 });

  const goToFabrics = (e) => {
    e.preventDefault();
    const el = document.getElementById("fabrics");
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { duration: 1.2 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  const goToContact = (e) => {
    e.preventDefault();
    const el = document.getElementById("contact");
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { duration: 1.2 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="pricing" data-testid="section-pricing" className="seam-top bg-ember">
      <div
        ref={ref}
        className={`mx-auto max-w-[900px] px-5 py-[120px] transition-[opacity,transform] duration-[600ms] ease-out md:px-7 ${
          shown ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"
        }`}
      >
        <p className="eyebrow text-xs text-kraft">Pricing</p>
        <h2 className="font-display mt-5 text-3xl font-extrabold leading-[1.08] text-warmwhite md:text-[40px]">
          Mill quality, without mill prices.
        </h2>

        <div className="mt-12 flex flex-col">
          {TIERS.map((tier, i) => (
            <div
              key={tier.label}
              data-testid="pricing-row"
              className={`flex flex-col gap-2 border-t border-dashed border-kraft py-7 md:flex-row md:items-baseline md:gap-10 transition-[opacity,transform] duration-[600ms] ease-out ${
                shown ? "translate-y-0 opacity-100" : "translate-y-3 opacity-0"
              }`}
              style={{ transitionDelay: shown ? `${i * 150}ms` : "0ms" }}
            >
              <p className="eyebrow w-56 shrink-0 text-[13px] text-warmwhite">{tier.label}</p>
              <p className="font-inter text-base leading-relaxed text-warmwhite/85">
                {tier.cta ? (
                  <>
                    <a
                      href="#contact"
                      onClick={goToContact}
                      data-testid="pricing-contact-link"
                      className="text-warmwhite underline decoration-kraft underline-offset-4 transition-colors duration-300 ease-out hover:text-kraft focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-kraft"
                    >
                      {tier.cta}
                    </a>{" "}
                    {tier.line}
                  </>
                ) : (
                  tier.line
                )}
              </p>
            </div>
          ))}
        </div>

        <a
          href="#fabrics"
          onClick={goToFabrics}
          data-testid="pricing-fabrics-link"
          className="eyebrow mt-10 inline-block text-[13px] text-warmwhite transition-colors duration-300 ease-out hover:text-kraft"
        >
          See what we carry →
        </a>
      </div>
    </section>
  );
};
